"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIDE_SIDEBAR_QUERY_KEY = exports.INTEGRATOR_TOKEN_HEADER_KEY = exports.TOKEN_HEADER_KEY = exports.TOKEN_COOKIE_NAME = void 0;
exports.TOKEN_COOKIE_NAME = "ms2token";
exports.TOKEN_HEADER_KEY = "X-MS2-Token";
exports.INTEGRATOR_TOKEN_HEADER_KEY = "X-INT-Token";
exports.HIDE_SIDEBAR_QUERY_KEY = "s";
